import React from "react";
import { Modal } from "react-bootstrap";

const DeactivateDialog = ({
  isDeactivateDialogOpen,
  setIsDeactivateDialogOpen,
  handleDeactivateConfirm,
}) => {
  return (
    <Modal
      show={isDeactivateDialogOpen}
      onHide={() => setIsDeactivateDialogOpen(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm desactivation</Modal.Title>
      </Modal.Header>
      <Modal.Body>Voulez vous desactivate cet utilisateur ?</Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={() => setIsDeactivateDialogOpen(false)}
        >
          Cancel
        </button>
        <button
          className="btn btn-warning"
          onClick={() => {
            handleDeactivateConfirm();
            setIsDeactivateDialogOpen(false);
          }}
        >
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeactivateDialog;
